import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b194be3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "upload-poster" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "message-1",
  class: "message-block"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "message-1__container" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Je poster is klaar.")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "message-2",
  class: "message-block"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "message-2__container" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Je ontvangt een e-mail met"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("jouw eigen verkiezingsposter.")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _hoisted_3
  ]))
}